import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { getAccessToken } from '../utils/auth.utils';
import { SysExternalWebUserType } from 'app/shared/enums/sys-application.enum';

@Injectable({
  providedIn: 'root',
})
export class RedirectionGuardService implements CanActivate {
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const token = getAccessToken();
    let decodedToken;
    if (token) {
      decodedToken = this.jwtHelper.decodeToken(token);
    }
    if (decodedToken && +decodedToken.sysExternalWebUserTypeId) {
      if (+decodedToken.sysExternalWebUserTypeId === SysExternalWebUserType.SSICSClientPortal) {
        return this.router.parseUrl('/mycontracts');
      } else if (+decodedToken.sysExternalWebUserTypeId === SysExternalWebUserType.SSICSASFPortal) {
        return this.router.parseUrl('/search');
      }
      return true;
    } else {
      return true;
    }
  }
}
